import React from 'react'
import SelectSearch from "react-select-search";
import {countries} from "../common/data";
import fuzzySearch from "../common/fuzzySearch";

const LocationForm = ({
                          handleSetCountry,
                          handleSetState,
                          handleSetCity,
                          SelectedCity,
                          submitted,
                          country,
                          state,
                          states,
                          city,
                          cities,
                          postcodes,
                          populatedPostCode,
                          handlePostcode,
                          handlePopulatedPostcode,
                          populatedAddress,
                          address,
                          setAddress,
                          setPostcode,
                          postcode,
                          displayCityPostCodeMessage,
                          displayCityNotHereMessage,
                      }) => {

    console.log('in LocationForm 2', displayCityPostCodeMessage, displayCityNotHereMessage, country, state, city)

    const allowEmpty = true

    return (
        <div>
            <div className='row'>
                <div className="col-xs-12 col-sm-2">
                    <label className='control-label'>Country <span className='required'>*</span></label>
                    <div className='form-group has-feedback has-error'>
                        <div className='input-section'>
                            <SelectSearch
                                search
                                autoComplete='nope'
                                emptyMessage='Not found'
                                placeholder='Select a country'
                                options={countries}
                                value={country}
                                filterOptions={fuzzySearch}
                                onChange={handleSetCountry}/>
                        </div>
                        {submitted && country === '' && (
                            <span className='error'>Please choose a country from the list above</span>)}
                    </div>
                </div>

                <div className="col-xs-12 col-sm-2">
                    <label className='control-label'>State <span className='required'>*</span></label>
                    <div className='form-group has-feedback has-error'>
                        <div className='input-section'>
                            <SelectSearch
                                search
                                autoComplete='nope'
                                emptyMessage='Not found'
                                placeholder='Select a state'
                                options={states}
                                value={state}
                                filterOptions={fuzzySearch}
                                onChange={handleSetState}/>
                        </div>
                        {submitted && state === '' && (
                            <span className='error'>Please choose a state from the list above</span>)}
                    </div>
                </div>

                <div className="col-xs-12 col-sm-2">
                    <label className='control-label'>City </label>
                    <div className='form-group has-feedback has-error'>
                        <div className='input-section'>
                            <SelectSearch
                                search
                                autoComplete='nope'
                                emptyMessage='Not found'
                                placeholder='Select a city'
                                options={cities}
                                value={SelectedCity}
                                filterOptions={fuzzySearch}
                                onChange={handleSetCity}/>
                        </div>
                        {submitted && SelectedCity === '' && (<span className='error'>Please choose a city from the list above</span>)}
                    </div>
                </div>

                <div className="col-xs-12 col-sm-2">
                    <label className='control-label'>Zip/Post Code</label>
                    <div className='form-group has-feedback'>
                        <div className='input-section'>
                            {postcodes.length > 0 && <SelectSearch
                                search
                                allowEmpty={allowEmpty}
                                autoComplete='nope'
                                emptyMessage='Not found'
                                placeholder='Select a zip/post code'
                                options={postcodes}
                                value={postcode}
                                filterOptions={fuzzySearch}
                                onChange={handlePostcode} />}
                            {(!postcodes || postcodes.length === 0) && <input type='text' value={ populatedPostCode ? populatedPostCode : postcode} onChange={e => handlePopulatedPostcode(e.target.value)} className='form-control' style={{height:36}} />}
                        </div>
                    </div>
                </div>

                <div className="col-xs-12 col-sm-4">
                    <label className='control-label'>Street Address</label>
                    <div className='form-group has-feedback'>
                        <div className='input-section'>
                            <input type='text' value={ populatedAddress ? populatedAddress : address} onChange={e => setAddress(e.target.value)} className='form-control' id='mobile_handset_emulator__address' style={{height:36}}/>											</div>
                    </div>
                </div>
            </div>
            {displayCityPostCodeMessage && (
                <div className='row'>
                    <div class='hidden-xs col-sm-offset-4 pl-20'>
                        <span>You can select a City and/or enter a Zip/Post Code</span>
                    </div>
                </div>
            )}
            {displayCityNotHereMessage && (
                <div className='row'>
                    <div class='hidden-xs col-sm-offset-4 pl-20'>
                        <span><a href='https://mobilemoxie.com/help/contact-us/' target='_blank'>Let us know</a> and we'll add it.</span>
                    </div>
                </div>
            )}
        </div>
    )
}

export default LocationForm